import RecordDoctorEdit from './src/doctor-edit'
import RecordImageList from './src/image-list'
import RecordRecordImageList from './src/record-image-list'
import RecordEdit from './src/record-edit'
import RecordConsultationEdit from './src/consultation-edit'
import RecordCourseEdit from './src/course-edit'
import RecordTransferEdit from './src/transfer'
import RecordConsultationListComments from './src/consultation-list-comments'
import RecordCommentsList from './src/comments-list'
import RecordWindowCard from './src/record-window-card'
import RecordWindowTable from './src/record-window-table'
import RecordPatientRecord from './src/patient-records'
import RecordPatientRecordSelection from './src/patient-record-selection'
import TimeLine from "./src/TimeLine";
import RecordTag from "./src/RecordTag";

const components = [
  RecordDoctorEdit,
  RecordImageList,
  RecordRecordImageList,
  RecordEdit,
  RecordConsultationEdit,
  RecordCourseEdit,
  RecordTransferEdit,
  RecordConsultationListComments,
  RecordCommentsList,
  RecordWindowCard,
  RecordWindowTable,
  RecordPatientRecord,
  RecordPatientRecordSelection,
  TimeLine,
  RecordTag
]

const install = function (Vue) {
  components.map(component => {
    Vue.component(component.name, component)
  })
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  version: '1.0.1',
  name: 'EberRecord',
  install,
  RecordDoctorEdit,
  RecordImageList,
  RecordRecordImageList,
  RecordEdit,
  RecordConsultationEdit,
  RecordCourseEdit,
  RecordTransferEdit,
  RecordConsultationListComments,
  RecordCommentsList,
  RecordWindowCard,
  RecordWindowTable,
  RecordPatientRecord,
  RecordPatientRecordSelection,
  TimeLine,
  RecordTag
}
